module.exports = __webpack_public_path__ + "img/icon-graphics.5302cab8.svg";